<template>
  <div class="closed-card" :class="variant" >
    <div class="card-color"/>
    <div class="card-content">
      <span class="title">{{ title }}</span>
      <span class="subtitle">{{ subTitle }}</span>
    </div>
    <div v-if="this.editFunc !== null" class="card-edit-button" v-on:click="this.editFunc">
      <img class="edit-icon" :src="require('../assets/mode-edit.svg')">
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClosedCard',
  props: {
    title: {
      type: String,
      default: 'title',
    },
    subTitle: {
      type: String,
      default: 'sub title',
    },
    editFunc: {
      type: Function,
      default: null,
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'success', 'warning', 'danger', 'disabled'].includes(value),
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';

  .closed-card {
    direction: rtl;
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow: hidden;
    height: 40px;
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 0 6px 0 $riseup_gray_1;

    .card-color {
      width: 8px;
    }

    .card-content {
      flex-grow: 1;
      line-height: 40px;
      padding-right: 15px;
      font-size: 16px;
      text-align: right;

      .title {
        font-weight: bold;
      }
    }

    .card-edit-button {
      line-height: 40px;
      width: 30px;
      cursor: pointer;

      .edit-icon {
        vertical-align: middle;
      }
    }

    &.primary .card-color {
      background-color: $riseup_blue;
    }

    &.success .card-color {
      background-color: $riseup_green;
    }
    &.danger .card-color {
      background-color: $riseup_danger_red;
    }
    &.warning .card-color {
      background-color: $riseup_yellow;
    }
    &.disabled {
      .card-color {
        background-color: $riseup_gray_2;
      }

      .card-content {
        color: $riseup_gray_2;
      }
    }
  }
</style>
